import React from "react";
import SectionHeading from "../SectionHeading";

export default function FeaturesSectionStyle5({ sectionTitle, data }) {
  return (
    <div className="container">
      <div className="cs_section_heading cs_style_1 text-center">
        <h2 className="cs_section_title cs_fs_72 m-0">{sectionTitle}</h2>
      </div>
      <div className="cs_height_72 cs_height_lg_50" />
      
      <div className="cs_mcp_why_choose_grid">
        {data?.map((item, index) => (
          <div className="cs_mcp_why_choose_card" key={index}>
            <div className="cs_mcp_why_choose_icon_wrap">
              <img src={item.iconUrl} alt={item.title} />
            </div>
            <h3 className="cs_mcp_why_choose_title">{item.title}</h3>
            <p className="cs_mcp_why_choose_desc">{item.subTitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
